import React from "react";
import { Typography } from "@material-ui/core";
import isFinite from "lodash/isFinite";
import DataTable from "Components/Shared/DataTable/DataTable";
import DataTableRow from "Components/Shared/DataTable/DataTableRow/DataTableRow";
import pretty from "Shared/pretty";

export interface NetPayStatsTableProps {
  netPayMinimum?: number;
  netPayMaximum?: number;
  netPayMean?: number;
  netPaySum?: number;
}

export const NetPayStatsTable = (props: NetPayStatsTableProps) => {
  const {
    netPayMinimum,
    netPayMaximum,
    netPayMean,
    netPaySum
  } = props;

  function formatStatAmount(amount: number) {
    return pretty.dollar(Math.round(amount * 100));
  }

  return (
    <DataTable title="Net Pay Stats" >
      {
        isFinite(netPayMinimum)
          ? (
            <DataTableRow>
              <Typography>Min</Typography>
              <Typography>{formatStatAmount(netPayMinimum!)}</Typography>
            </DataTableRow>
          )
          : <></>
      }
      {
        isFinite(netPayMaximum)
          ? (
            <DataTableRow>
              <Typography>Max</Typography>
              <Typography>{formatStatAmount(netPayMaximum!)}</Typography>
            </DataTableRow>
          )
          : <></>
      }
      {
        isFinite(netPayMean)
          ? (
            <DataTableRow>
              <Typography>Average</Typography>
              <Typography>{formatStatAmount(netPayMean!)}</Typography>
            </DataTableRow>
          )
          : <></>
      }
      {
        isFinite(netPaySum)
          ? (
            <DataTableRow>
              <Typography>Total</Typography>
              <Typography>{formatStatAmount(netPaySum!)}</Typography>
            </DataTableRow>
          )
          : <></>
      }
    </DataTable>
  );
};
